import React, { Fragment } from 'react';
import { useI18n } from '../../i18n';
import ListIconTick from './ListIconTick';
import { InfoModalContentTextKeys } from './types';

import S from './style/InfoModal';

interface InfoModalContentProps {
  contentTextKeys: InfoModalContentTextKeys;
}

const InfoModalContent: React.FC<InfoModalContentProps> = ({ contentTextKeys }) => {
  const i18n = useI18n();

  const content = contentTextKeys.reduce((acc, keys) => {
    const component = (
      <Fragment key={keys.tickDescription}>
        <S.ListItem>
          <ListIconTick data-testid="content-tick" />
          <div>
            {keys.tickHeader && (
              <p>
                <strong>{i18n(`${keys.tickHeader}`)}</strong>
              </p>
            )}
            <p>
              {keys.tickImportant && (
                <>
                  <strong>{i18n(`${keys.tickImportant}`)}</strong>{' '}
                </>
              )}
              {keys.tickDescription && i18n(`${keys.tickDescription}`)}
              {keys.specificTickDescription && keys.specificTickDescription}
            </p>
          </div>
        </S.ListItem>
        {keys.tickPoint &&
          keys.tickPoint.map((item, i) => (
            // eslint-disable-next-line react/no-array-index-key
            <S.ListItemDot key={i} data-testid="content-tick-point">
              <S.MidDoT>&#8226;</S.MidDoT>
              {item}
            </S.ListItemDot>
          ))}
      </Fragment>
    );

    acc.push(component);
    return acc;
  }, []);

  return <div data-testid="info-modal-content">{content}</div>;
};

export default InfoModalContent;
